import { render } from "./OurCars.vue?vue&type=template&id=1392c4af"
import script from "./OurCars.vue?vue&type=script&lang=js"
export * from "./OurCars.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__